import { useEffect, useRef, useState } from "react";
import "./UpdatedFieldsFilter.css";

export const UPDATED_FIELDS_FILTER = {
  UPDATED_ONLY: "updated_only",
  ALL: "all",
};

const OPTIONS = [
  {
    key: UPDATED_FIELDS_FILTER.UPDATED_ONLY,
    label: "Updated Fields Only",
    description: "Show only fields that have been updated by the candidate",
    showFilterIcon: true,
  },
  {
    key: UPDATED_FIELDS_FILTER.ALL,
    label: "All Fields",
    description: "Show all fields (updated and non-updated)",
    showFilterIcon: false,
  },
];

const UpdatedFieldsFilter = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected =
    OPTIONS.find((option) => option.key === value) || OPTIONS[0];

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <div className="rr-updated-filter" ref={rootRef}>
      <button
        type="button"
        className={`rr-updated-filter__trigger${open ? " is-open" : ""}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span
          className="material-symbols-rounded rr-updated-filter__icon"
          aria-hidden="true"
        >
          filter_alt
        </span>
        <span className="rr-updated-filter__trigger-text">
          Show:{" "}
          {selected.key === UPDATED_FIELDS_FILTER.UPDATED_ONLY
            ? "Updated Fields"
            : "All Fields"}
        </span>
        <span
          className={`material-symbols-rounded rr-updated-filter__chevron${
            open ? " is-open" : ""
          }`}
          aria-hidden="true"
        >
          expand_more
        </span>
      </button>

      {open ? (
        <div className="rr-updated-filter__menu" role="listbox">
          {OPTIONS.map((option) => {
            const isSelected = option.key === selected.key;
            return (
              <button
                key={option.key}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`rr-updated-filter__option${
                  isSelected ? " is-selected" : ""
                }`}
                onClick={() => {
                  onChange?.(option.key);
                  setOpen(false);
                }}
              >
                <div className="rr-updated-filter__option-head">
                  {option.showFilterIcon ? (
                    <span
                      className="material-symbols-rounded rr-updated-filter__icon"
                      aria-hidden="true"
                    >
                      filter_alt
                    </span>
                  ) : (
                    <span
                      className="rr-updated-filter__icon-placeholder"
                      aria-hidden="true"
                    />
                  )}
                  <span className="rr-updated-filter__option-label">
                    {option.label}
                  </span>
                  {isSelected ? (
                    <span
                      className="material-symbols-rounded rr-updated-filter__check"
                      aria-hidden="true"
                    >
                      check
                    </span>
                  ) : (
                    <span className="rr-updated-filter__check-spacer" />
                  )}
                </div>
                <p className="rr-updated-filter__option-desc">
                  {option.description}
                </p>
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default UpdatedFieldsFilter;
